import { fork } from 'redux-saga/effects';
import companySaga from './companySaga';

export default function* backyardSaga() {
  yield fork(companySaga);
}
